"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[826],{

/***/ 68106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ CheckoutContext; },
  "o": function() { return /* binding */ CheckoutProvider; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./client/contexts/Purchase/selectors.js
var selectors = __webpack_require__(5755);
// EXTERNAL MODULE: ./src/hooks/useSystem.ts
var useSystem = __webpack_require__(72337);
;// CONCATENATED MODULE: ./client/components/CheckoutContainer/utils.js
function createHoldersFromBoards(count) {
    return new Array(count).fill().map(function() {
        return {
            name: "",
            last: "",
            email: "",
            errors: []
        };
    });
}

// EXTERNAL MODULE: ../../node_modules/react-use/esm/useEffectOnce.js
var useEffectOnce = __webpack_require__(69904);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./client/components/CheckoutContainer/context.js
/* eslint-disable react/prop-types */ 










var CheckoutContext = /*#__PURE__*/ react.createContext();
var CheckoutProvider = function(param) {
    var additionalProductsSelections = param.additionalProductsSelections, _additionalProductsDismissed = param.additionalProductsDismissed, additionalProductsDismissed = _additionalProductsDismissed === void 0 ? {} : _additionalProductsDismissed, _boards = param.boards, boards = _boards === void 0 ? [] : _boards, children = param.children, insuranceIds = param.insuranceIds, insuranceQuotes = param.insuranceQuotes, payNowIds = param.payNowIds, purchaseId = param.purchaseId, priceDropProtectionQuote = param.priceDropProtectionQuote;
    var apiHostName = (0,useSystem/* useSystem */.u)().apiHostName;
    var customerData = (0,es/* useSelector */.v9)(selectors/* getCustomerData */.ck);
    var insuranceIdsStored = (0,es/* useSelector */.v9)(selectors/* getInsuranceIds */.xX);
    var autoNewsletterSubscribe = (0,useMarket/* useMarket */.A)().autoNewsletterSubscribe;
    var count = boards.reduce(function(acc, board) {
        return acc + parseInt(board.roomsNumber);
    }, 0);
    var isMultiRoom = count > 1;
    var isPhysicalAddressRequired = boards.some(function(board) {
        return board.isPhysicalAddressRequired === true;
    });
    var holdersStored = (0,es/* useSelector */.v9)(selectors/* getHolders */.b);
    var holders = count === 1 ? [] : createHoldersFromBoards(count);
    if (holdersStored.length === count && holdersStored) {
        holders = holdersStored.map(function(holderStored) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, holderStored), {
                errors: []
            });
        });
    }
    var selectedInsuranceIds = (insuranceIdsStored === null || insuranceIdsStored === void 0 ? void 0 : insuranceIdsStored.length) ? insuranceIdsStored : insuranceIds;
    var boardsWihtInsurance = boards.filter(function(board) {
        return selectedInsuranceIds.includes(board.availabilityId);
    });
    var initialInsuranceSelections = (0,react.useMemo)(function() {
        return boards.map(function(board) {
            var ref;
            if ((board === null || board === void 0 ? void 0 : (ref = board.insurance) === null || ref === void 0 ? void 0 : ref.amount) > 0) {
                return {
                    isInsured: selectedInsuranceIds.includes(board.availabilityId) ? true : null,
                    availabilityId: board.availabilityId
                };
            }
            return null;
        }).filter(Boolean);
    }, [
        boards,
        selectedInsuranceIds
    ]);
    var ref = (0,react.useState)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customerData), {
        additionalProductsSelections: additionalProductsSelections,
        additionalProductsDismissed: additionalProductsDismissed,
        hostname: apiHostName,
        boardsWihtInsurance: boardsWihtInsurance,
        insuranceSelections: initialInsuranceSelections,
        holders: holders,
        isPhysicalAddressRequired: isPhysicalAddressRequired,
        payNowIds: payNowIds,
        priceDropProtectionQuote: priceDropProtectionQuote
    })), checkout = ref[0], setCheckout = ref[1];
    var ref1 = (0,react.useState)(false), isEditingCreditCard = ref1[0], setIsEditingCreditCard = ref1[1];
    (0,react.useEffect)(function() {
        setCheckout((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, checkout, customerData), {
            boardsWihtInsurance: boardsWihtInsurance,
            insuranceSelections: initialInsuranceSelections,
            holders: holders,
            subscribeNewsletter: autoNewsletterSubscribe !== null && autoNewsletterSubscribe !== void 0 ? autoNewsletterSubscribe : false
        }));
    }, [
        customerData.email
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    (0,useEffectOnce/* default */.Z)(function() {
        setCheckout((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, checkout), {
            subscribeNewsletter: autoNewsletterSubscribe !== null && autoNewsletterSubscribe !== void 0 ? autoNewsletterSubscribe : false
        }));
    });
    var state = (0,react.useMemo)(function() {
        return {
            boards: boards,
            checkout: checkout,
            insuranceQuotes: insuranceQuotes,
            isMultiRoom: isMultiRoom,
            purchaseId: purchaseId,
            priceDropProtectionQuote: priceDropProtectionQuote,
            setCheckout: setCheckout,
            isEditingCreditCard: isEditingCreditCard,
            setIsEditingCreditCard: setIsEditingCreditCard
        };
    }, [
        boards,
        checkout,
        insuranceQuotes,
        isMultiRoom,
        purchaseId,
        priceDropProtectionQuote,
        setCheckout,
        isEditingCreditCard,
        setIsEditingCreditCard, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutContext.Provider, {
        value: state,
        children: children
    });
};
CheckoutProvider.propTypes = {
    additionalProductsSelections: (prop_types_default()).object,
    boards: (prop_types_default()).array,
    children: (prop_types_default()).node,
    insuranceIds: prop_types_default().arrayOf((prop_types_default()).string),
    insuranceQuotes: (prop_types_default()).object,
    payNowIds: prop_types_default().arrayOf((prop_types_default()).string),
    purchaseId: (prop_types_default()).string,
    priceDropProtectionQuote: prop_types_default().shape({
        key: (prop_types_default()).string,
        value: prop_types_default().arrayOf(prop_types_default().shape({
            id: (prop_types_default()).number,
            fee: (prop_types_default()).number.isRequired,
            currency: (prop_types_default()).string.isRequired
        }))
    })
};



/***/ }),

/***/ 59896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZE": function() { return /* binding */ getJsonLd; }
});

// UNUSED EXPORTS: setJsonLdAccommodation, setJsonLdBreadcrumb, setSameAsByMarket

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./client/components/JsonLd/constants.js
var jsonld = {
    "@context": "https://schema.org",
    "@type": "Organization",
    address: {
        "@type": "PostalAddress",
        addressCountry: "ES",
        addressLocality: "Barcelona",
        addressRegion: "Barcelona",
        postalCode: "08010",
        streetAddress: "Ronda Sant Pere 17, 3\xba 4\xaa"
    },
    founders: [
        {
            "@type": "Person",
            name: "Luis Osorio Sol\xe9"
        },
        {
            "@type": "Person",
            name: "Francesc L\xf3pez Castellet"
        },
        {
            "@type": "Person",
            name: "Ra\xfal Mor\xf3n Sillero"
        }, 
    ],
    foundingDate: "2015-01-29",
    foundingLocation: "Barcelona",
    legalName: "Stayforlong S.L.",
    logo: {
        "@type": "ImageObject",
        caption: "Stayforlong logo",
        url: "https://static.stayforlong.com/web/images/sfl-logo-mobile.jpg"
    },
    name: "Stayforlong",
    url: "https://www.stayforlong.com"
};
var descriptions = {
    es: "Stayforlong es un sitio web de reservas hoteleras especializado en las reservas de larga estancia. Se encuentra presente en 22 pa\xedses distintos y ofrece a sus clientes una cartera formada por m\xe1s de 720.000 establecimientos hoteleros. Stayforlong tiene su sede en la ciudad de Barcelona.",
    de: "Stayforlong ist eine Hotelreservierungswebseite spezialisiert auf Langzeitaufenthalte. Wir sind pr\xe4sent in 22 verschiedenen L\xe4ndern und bieten unseren Kunden ein Portfolio von mehr als 720.000 Hotels. Stayforlong hat den Hauptsitz in Barcelona.",
    fr: "Stayforlong est un portail de r\xe9servation d'h\xf4tels sp\xe9cialis\xe9 dans les longs s\xe9jours.Nous sommes pr\xe9sents dans 22 pays et proposons \xe0 nos utilisateurs plus de 720.000 h\xf4tels diff\xe9rents.",
    uk: "Stayforlong is a hotel reservation portal specialized in long stays. We are present in 22 countries and offer to our clients more than 720.000 different hotels. Stayforlong's headquarter is located in Barcelona, Spain.",
    pt: "Stayforlong \xe9 um portal de reservas de hot\xe9is especializado em estadias longas. Estamos presentes em 22 pa\xedses e oferecemos aos nossos usu\xe1rios mais de 720.000 hot\xe9is diferentes."
};
var sameAs = [
    "https://www.facebook.com/stayforlong",
    "https://www.instagram.com/stayforlong",
    "https://www.youtube.com/channel/UCXY0iWptc19iyKlVqkK1ZGw", 
];

// EXTERNAL MODULE: ./src/constants/countries.ts
var countries = __webpack_require__(83404);
;// CONCATENATED MODULE: ./client/components/JsonLd/mappers.js

function setAddress(param) {
    var street = param.street, locality = param.locality, region = param.region, _country = param.country, country = _country === void 0 ? DEFAULT_COUNTRY.market : _country, postalCode = param.postalCode;
    return {
        "@type": "PostalAddress",
        streetAddress: street,
        addressLocality: locality,
        addressRegion: region,
        postalCode: postalCode,
        addressCountry: country
    };
}
var setAmenities = function(amenities) {
    return amenities.map(function(amenity) {
        return {
            "@type": "LocationFeatureSpecification",
            value: "True",
            name: amenity.name
        };
    });
};
var mappers_mapJsonLdTypeDetail = function(accommodation, addressParam) {
    var accommodationType = accommodation.accommodationType, name = accommodation.name, url = accommodation.url, image = accommodation.photo, description = accommodation.description, latitude = accommodation.latitude, longitude = accommodation.longitude, rating = accommodation.rating, facilities = accommodation.facilities;
    return {
        "@context": "http://schema.org",
        "@type": accommodationType.toLowerCase(),
        name: name,
        url: url,
        image: image,
        description: description,
        address: setAddress(addressParam),
        geo: {
            "@type": "GeoCoordinates",
            latitude: latitude,
            longitude: longitude
        },
        starRating: {
            "@type": "http://schema.org/Rating",
            ratingValue: rating
        },
        amenityFeature: setAmenities(facilities)
    };
};
var mappers_mapJsonLdBreadcrumb = function(param) {
    var urlHome = param.urlHome, urlList = param.urlList, urlDetail = param.urlDetail, listTitle = param.listTitle, detailTitle = param.detailTitle;
    return {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: urlHome
            },
            {
                "@type": "ListItem",
                position: 2,
                name: listTitle,
                item: urlList
            },
            {
                "@type": "ListItem",
                position: 3,
                name: detailTitle,
                item: urlDetail
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./client/components/JsonLd/utils.js





function setJsonLdBreadcrumb(params) {
    return JSON.stringify(mapJsonLdBreadcrumb(params));
}
function setJsonLdAccommodation(accommodation, addressParam) {
    return JSON.stringify(mapJsonLdTypeDetail(accommodation, addressParam));
}
function setSameAsByMarket(market) {
    var linkedinMarket = market !== "es" && market !== "de" && market !== "fr" && market !== "pt" ? "https://www.linkedin.com/company/stayforlong" : "https://".concat(market, ".linkedin.com/company/stayforlong");
    var twitterMarket = market === "es" ? "https://twitter.com/stayforlong_es" : "https://twitter.com/stayforlong";
    return (0,_to_consumable_array/* default */.Z)(sameAs).concat([
        linkedinMarket,
        twitterMarket
    ]);
}
function getJsonLd(market) {
    var jsonLdMarket = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonld), {
        sameAs: setSameAsByMarket(market)
    });
    if (!descriptions[market]) {
        return JSON.stringify(jsonLdMarket);
    }
    return JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jsonLdMarket), {
        description: descriptions[market]
    }));
}


/***/ }),

/***/ 5755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F0": function() { return /* binding */ getPurchaseEmail; },
/* harmony export */   "_w": function() { return /* binding */ getIsMandatory; },
/* harmony export */   "b": function() { return /* binding */ getHolders; },
/* harmony export */   "ck": function() { return /* binding */ getCustomerData; },
/* harmony export */   "xX": function() { return /* binding */ getInsuranceIds; }
/* harmony export */ });
/* unused harmony export getCustomerEmail */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5994);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70155);


var getCustomerData = function(state) {
    return state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .PURCHASE_STATE */ .lT];
};
var getCustomerEmail = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .PURCHASE_STATE */ .lT]) === null || ref === void 0 ? void 0 : ref.email;
};
var getHolders = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .PURCHASE_STATE */ .lT]) === null || ref === void 0 ? void 0 : ref.holders;
};
var getInsuranceIds = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .PURCHASE_STATE */ .lT]) === null || ref === void 0 ? void 0 : ref.insuranceIds;
};
var getIsMandatory = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .PURCHASE_STATE */ .lT]) === null || ref === void 0 ? void 0 : ref.isMandatory;
};
var getPurchaseEmail = (0,reselect__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([
    getCustomerEmail,
    getHolders
], function(email, holders) {
    var ref;
    return ((ref = holders[0]) === null || ref === void 0 ? void 0 : ref.email) || email;
});


/***/ }),

/***/ 57598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nw": function() { return /* binding */ mapPaymentAliasErrorMessage; },
/* harmony export */   "dI": function() { return /* binding */ mapPaymentMethodsErrorMessage; },
/* harmony export */   "hy": function() { return /* binding */ mapConfirmationErrorMessage; },
/* harmony export */   "mt": function() { return /* binding */ mapUpdatePurchaseErrorMessage; }
/* harmony export */ });
function mapUpdatePurchaseErrorMessage(errorMessage, status) {
    if (status === 400) {
        return "update_purchase_request";
    }
    if (errorMessage.includes("Availability not bookable")) {
        return "update_purchase_booking_rules_confirmation";
    }
    if (errorMessage.includes("Availabilities not found")) {
        return "update_purchase_av_not_found";
    }
    if (errorMessage.includes("Property ID") && errorMessage.includes("not match with Availability property")) {
        return "update_purchase_property_id_dismatch";
    }
    if (errorMessage.includes("Purchase ID") && errorMessage.includes("not found for this PreOrder")) {
        return "update_purchase_id_not_found";
    }
    if (errorMessage.includes("User not found")) {
        return "update_purchase_user_not_found";
    }
    if (errorMessage.includes("Bad Request to users with")) {
        return "update_purchase_bad_request_to_users";
    }
    if (errorMessage.includes("Invalid user for Purchase ID")) {
        return "update_purchase_invalid_user";
    }
    return "update_purchase";
}
function mapPaymentAliasErrorMessage(errorMessage, status) {
    if (status === 400) {
        return "payment_alias_request";
    }
    if (errorMessage.includes("Purchase ID") && errorMessage.includes("not found for this PreOrder")) {
        return "payment_alias_purchase_id_not_found";
    }
    if (errorMessage.includes("User not found for Purchase ID")) {
        return "payment_alias_user_not_found";
    }
    return "payment_alias";
}
function mapPaymentMethodsErrorMessage(errorMessage, status) {
    if (status === 400) {
        return "payment_methods_request";
    }
    if (errorMessage.includes("Purchase ID") && errorMessage.includes("not found for this PreOrder")) {
        return "payment_methods_purchase_id_not_found";
    }
    if (errorMessage.includes("Availability not found")) {
        return "payment_methods_av_not_found";
    }
    if (errorMessage.includes("User not found for Purchase ID")) {
        return "payment_methods_user_not_found";
    }
    return "payment_methods";
}
function mapConfirmationErrorMessage(errorMessage, status) {
    if (status === 400) {
        return "confirmation_request";
    }
    if (errorMessage.includes("User not found for Purchase ID")) {
        return "confirmation_user_not_found";
    }
    if (errorMessage.includes("Availability with identifier") && errorMessage.includes("not found!")) {
        return "confirmation_av_not_found";
    }
    if (errorMessage.includes("Purchase ID") && errorMessage.includes("is locked for confirmation")) {
        return "confirmation_purchase_locked";
    }
    if (errorMessage.includes("Purchase ID") && errorMessage.includes("not found for this PreOrder")) {
        return "confirmation_purchase_id_not_found";
    }
    return "confirmation";
}


/***/ }),

/***/ 77555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Home_Head; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/constants/business.js
var business = __webpack_require__(17003);
// EXTERNAL MODULE: ./client/components/JsonLd/utils.js + 2 modules
var utils = __webpack_require__(59896);
// EXTERNAL MODULE: ./lib/utils/page.ts
var page = __webpack_require__(96011);
// EXTERNAL MODULE: ./src/comps/HrefLangs/index.js + 1 modules
var HrefLangs = __webpack_require__(15363);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./client/pages/Home/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    title: {
        id: "page.home.title"
    },
    description: {
        id: "page.home.description"
    },
    bannerText: {
        id: "banner.text"
    },
    bannerTitle: {
        id: "banner.title"
    },
    homeTitle: {
        id: "hero.best-hotels-for-your-holidays"
    }
});
/* harmony default export */ var Home_messages = (messages);

// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
;// CONCATENATED MODULE: ./client/pages/Home/Head.tsx










var Head = function(props) {
    var _pathname = props.pathname, pathname = _pathname === void 0 ? "" : _pathname;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,useMarket/* useMarket */.A)(), language = ref.language, market = ref.market, subdomain = ref.subdomain, topdomain = ref.topdomain;
    var title = "".concat(business/* BRAND_NAME_TITLE */.W_, ": ").concat(intl.formatMessage(Home_messages.title));
    var description = intl.formatMessage(Home_messages.description, {
        brand: business/* BRAND_NAME_TITLE */.W_
    });
    var canonicalURL = (0,page/* buildCanonicalURL */._L)({
        market: market,
        language: language,
        pathname: pathname,
        subdomain: subdomain,
        topdomain: topdomain
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: (0,utils/* getJsonLd */.ZE)(market)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HrefLangs/* default */.Z, {
                pathname: pathname
            })
        ]
    });
};
/* harmony default export */ var Home_Head = (Head);


/***/ }),

/***/ 33665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_ListItem; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/comps/ListItem/styles.js
var styles = __webpack_require__(73919);
// EXTERNAL MODULE: ./client/icons/createSvgIcon.tsx + 1 modules
var createSvgIcon = __webpack_require__(88121);
;// CONCATENATED MODULE: ./client/icons/Ellipse.js



/* harmony default export */ var Ellipse = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "2"
}), "Ellipse"));

;// CONCATENATED MODULE: ./src/comps/ListItem/index.js





var ListItem = function(param) {
    var icon = param.icon, children = param.children;
    var ListIcon = icon || Ellipse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ListItemBase */.Ky, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IconWrapper */.a1, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ContentWrapper */.vs, {
                children: children
            })
        ]
    });
};
ListItem.propTypes = {
    icon: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var comps_ListItem = (ListItem);


/***/ }),

/***/ 73919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ky": function() { return /* binding */ ListItemBase; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12411);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding-block-end: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-inline-start: 8px;\n  line-height: 150%;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ListItemBase = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ListItemBase",
    componentId: "sc-b1b3719d-0"
})(_templateObject());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__IconWrapper",
    componentId: "sc-b1b3719d-1"
})(_templateObject1(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2);
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__ContentWrapper",
    componentId: "sc-b1b3719d-2"
})(_templateObject2(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2);


/***/ })

}]);